import Dispatcher from 'live/lib/dispatcher'
import Constants from './constants'

const Factory = (namespace) => {
    const Actions = {
        getQueries: function(qualifier) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: Constants.GET_QUERIES,
                params: { qualifier }
            })
        },
        explainQuery: function(qualifier, queryInfo, index) {
            Dispatcher.handle({
                namespace: namespace,
                actionType: Constants.EXPLAIN_QUERY,
                params: { qualifier, queryInfo, index }
            })
        }
    }

    return Actions
}

export default Factory
